import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'
import dayjs from 'dayjs'

class AccumulatorChange extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined

    this._id = init.id
    this._employee_id = init.employee_id
    this._client_name = init.client_name
    this._description = init.description
    this._effective_date = init.effective_date
    this._accumulator_changes = init.accumulator_changes
    this._groups_affected = init.groups_affected
    this._groups_id_cards = init.groups_id_cards
    this._reprint_scope = init.reprint_scope
    this._source_attachments = init.source_attachments
  }

  static shape = {
    id: PropTypes.number,
    employee_id: PropTypes.number,
    client_name: PropTypes.string,
    description: PropTypes.string,
    effective_date: PropTypes.string,
    accumulator_changes: PropTypes.string,
    groups_affected: PropTypes.string,
    groups_id_cards: PropTypes.string,
    reprint_scope: PropTypes.string,
    source_attachments: PropTypes.array
  }

  get id() {
    return this._id
  }

  get employee_id() {
    return this._employee_id
  }

  get client_name() {
    return this._client_name
  }

  get description() {
    return this._description
  }

  get effective_date() {
    return this._effective_date
      ? dayjs(new Date(this._effective_date).toISOString())
      : null
  }

  get accumulator_changes() {
    return this._accumulator_changes
  }

  get groups_affected() {
    return this._groups_affected
  }

  get groups_id_cards() {
    return this._groups_id_cards
  }

  get reprint_scope() {
    return this._reprint_scope
  }

  get source_attachments() {
    return this._source_attachments
  }
}

export default AccumulatorChange
